
import { HeaderLogo } from "./HeaderLogo";
import { MissionsMenu } from "./MissionsMenu";
import { NotificationsMenu } from "./NotificationsMenu";
import { LanguageSelector } from "./LanguageSelector";
import { AuthButton } from "@/components/auth/AuthButton";
import { MobileHamburgerMenu } from "./MobileHamburgerMenu";
import { useIsMobile } from "@/hooks/use-mobile";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { ThemeToggle } from "@/components/ui/theme-toggle";

const AppHeader = () => {
  const isMobile = useIsMobile();

  // Mobile header styling
  if (isMobile) {
    return (
      <header className="fixed top-0 left-0 right-0 z-50 bg-background border-b border-border">
        <div className="flex items-center justify-between px-4 h-16">
          <HeaderLogo compact={true} />
          <div className="flex items-center gap-2">
            <ThemeToggle />
            <LanguageSelector />
            <MobileHamburgerMenu />
          </div>
        </div>
      </header>
    );
  }

  // Desktop header styling
  return (
    <header className="border-b border-border bg-background w-full fixed top-0 left-0 right-0 z-50">
      <div className="w-full h-16 flex items-center justify-between px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3">
          <SidebarTrigger className="h-8 w-8 hover:bg-primary/10" />
          <HeaderLogo />
        </div>
        <div className="flex items-center gap-4">
          <ThemeToggle />
          <LanguageSelector />
          <MissionsMenu />
          <NotificationsMenu />
          <AuthButton />
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
